function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8 1.53333H9.2C6.98819 1.53333 5.48359 1.53659 4.35686 1.68807C3.27425 1.83363 2.77281 2.09026 2.43154 2.43154C2.09026 2.77281 1.83363 3.27425 1.68807 4.35686C1.53659 5.48359 1.53333 6.98819 1.53333 9.2V13.8C1.53333 16.0118 1.53659 17.5164 1.68807 18.6431C1.83363 19.7258 2.09026 20.2272 2.43154 20.5685C2.77281 20.9097 3.27425 21.1664 4.35686 21.3119C5.48359 21.4634 6.98819 21.4667 9.2 21.4667H13.8C16.0118 21.4667 17.5164 21.4634 18.6431 21.3119C19.7258 21.1664 20.2272 20.9097 20.5685 20.5685C20.9097 20.2272 21.1664 19.7258 21.3119 18.6431C21.4634 17.5164 21.4667 16.0118 21.4667 13.8V9.2C21.4667 6.98819 21.4634 5.48359 21.3119 4.35686C21.1664 3.27425 20.9097 2.77281 20.5685 2.43154C20.2272 2.09026 19.7258 1.83363 18.6431 1.68807C17.5164 1.53659 16.0118 1.53333 13.8 1.53333ZM1.34731 1.34731C0 2.69462 0 4.86308 0 9.2V13.8C0 18.1369 0 20.3054 1.34731 21.6527C2.69462 23 4.86308 23 9.2 23H13.8C18.1369 23 20.3054 23 21.6527 21.6527C23 20.3054 23 18.1369 23 13.8V9.2C23 4.86308 23 2.69462 21.6527 1.34731C20.3054 0 18.1369 0 13.8 0H9.2C4.86308 0 2.69462 0 1.34731 1.34731Z",
  fill: "#B7B0FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 9.2C0 4.86308 0 2.69462 1.34731 1.34731C2.69462 0 4.86308 0 9.2 0H13.8C18.1369 0 20.3054 0 21.6527 1.34731C23 2.69462 23 4.86308 23 9.2V13.8C23 18.1369 23 20.3054 21.6527 21.6527C20.3054 23 18.1369 23 13.8 23H9.2C4.86308 23 2.69462 23 1.34731 21.6527C0 20.3054 0 18.1369 0 13.8V9.2Z",
  fill: "#6F62FF",
  fillOpacity: 0.1
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.9439 15.3904C13.8009 15.3904 12.8712 14.4607 12.8712 13.3177C12.8712 12.9357 12.5621 12.6267 12.1802 12.6267C11.7983 12.6267 11.4893 12.9357 11.4893 13.3177C11.4893 15.2231 13.0385 16.7723 14.9439 16.7723C15.3258 16.7723 15.6349 16.4632 15.6349 16.0813C15.6349 15.6995 15.3258 15.3904 14.9439 15.3904Z",
  fill: "#B7B0FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.1802 9.86255C10.2747 9.86255 8.72559 11.4118 8.72559 13.3172C8.72559 16.1254 10.6998 17.5086 11.8766 18.0834C11.9751 18.1307 12.0777 18.1536 12.1803 18.1536C12.4353 18.1536 12.6809 18.0106 12.801 17.7663C12.9683 17.4235 12.8266 17.0092 12.4839 16.8419C11.4002 16.3129 10.1074 15.2711 10.1074 13.3171C10.1074 12.1741 11.0372 11.2443 12.1802 11.2443C13.3232 11.2443 14.253 12.1741 14.253 13.3171C14.253 13.699 14.562 14.008 14.9439 14.008C15.3258 14.008 15.6349 13.699 15.6349 13.3171C15.6348 11.4118 14.0856 9.86255 12.1802 9.86255Z",
  fill: "#B7B0FF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.1802 7.09912C8.75122 7.09912 5.96191 9.88849 5.96191 13.3174C5.96191 15.0474 6.47201 16.6695 7.39912 17.8827C7.53541 18.0608 7.74055 18.1539 7.94835 18.1539C8.09545 18.1539 8.24255 18.1081 8.36802 18.0122C8.67168 17.7801 8.72965 17.3469 8.49757 17.0433C7.76478 16.0838 7.34374 14.7249 7.34374 13.3174C7.34374 10.6509 9.51368 8.48095 12.1802 8.48095C14.8468 8.48095 17.0167 10.6509 17.0167 13.3174C17.0167 13.7264 16.9654 14.1339 16.8643 14.528C16.7698 14.8964 16.9925 15.2742 17.3622 15.3687C17.728 15.4631 18.1085 15.2405 18.203 14.8707C18.3325 14.3659 18.3986 13.8424 18.3986 13.3174C18.3986 9.88843 15.6092 7.09912 12.1802 7.09912Z",
  fill: "#B7B0FF"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.1692 6.62436C16.5216 5.14809 14.3948 4.33569 12.1803 4.33569C9.1616 4.33569 6.36277 5.83897 4.69218 8.35578C4.48166 8.67427 4.56801 9.10204 4.8865 9.31392C5.00394 9.39087 5.13614 9.42863 5.26841 9.42863C5.4911 9.42863 5.71101 9.32065 5.84464 9.1196C7.2575 6.98878 9.62584 5.71759 12.1804 5.71759C14.0535 5.71759 15.8536 6.40445 17.249 7.65272C17.531 7.9078 17.9682 7.8848 18.2233 7.59876C18.4783 7.31531 18.454 6.87808 18.1692 6.62436Z",
  fill: "#B7B0FF"
});

var SvgDataBank = function SvgDataBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDataBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dataBank.b45619da.svg";
export { ForwardRef as ReactComponent };